<template>
  <ModalPage :goBackTo="{name: 'conversations'}" :canGoBack="canGoBack">
    <input type="text" v-model="search" class="border w-full p-4 focus:outline-none focus:shadow focus:border-cardstock-green-500" placeholder="Type a name or a number" @click.stop>
    <div class="min-h-80" @click="didClickItem">
      <div v-for="homeNumber in messageRecipients" :key="homeNumber.id">

        <button
          v-if="homeNumber.__typename == 'ProvisionalNewHomeNumber'"
          class="w-full block px-4 cursor-pointer hover:bg-gray-300 h-16 flex flex-col justify-center text-black text-base focus:border-cardstock-green-500 focus:border focus:bg-cardstock-green-40 focus:outline-none"
          @click="didCreateProposedNewHomeNumber(homeNumber)"
        >
          {{homeNumber.formattedNumber}}
        </button>
        <router-link
          v-else
          :to="{ name: 'homeNumber', params: { homeNumberId: homeNumber.id }}"
          class="w-full block px-4 cursor-pointer hover:bg-gray-300 h-16 flex flex-col justify-center text-black text-base focus:border-cardstock-green-500 focus:border focus:bg-cardstock-green-40 outline-none"
          @click="alert('howdy')"
        >
          <div>
            <strong>{{labelDisplay(homeNumber)}}</strong> <span class="ml-2 text-gray-800 text-sm">{{numberDisplay(homeNumber)}}</span>
          </div>
          <div>
            {{studentDisplay(homeNumber)}}
          </div>
        </router-link>
      </div>

      <div class="p-4 flex flex-col items-center justify-center min-h-80 text-gray-600" v-if="!hasRecipients">
        <div class="font-bold text-lg text-center">No numbers found</div>
        <div class="mt-1 text-sm text-center">
          Search for a Cardstock student's home number,<br/>or enter a new, valid US phone number to message...</div>
      </div>
    </div>
  </ModalPage>
</template>

<script>
import gql       from 'graphql-tag'
import _get      from 'lodash-es/get'

import ModalPage from '@/components/ModalPage.vue'

export default {
  components: {
    ModalPage
  },

  props: {
    teamId: {
      required: true
    },
    canGoBack: {
      default: false
    }
  },

  data() {
    return {
      search: null,
      hasMounted: !(this.canGoBack == true)
    }
  },

  computed: {
    hasRecipients() {
      return _get(this, 'messageRecipients', []).length > 0
    }
  },

  mounted() {
    this.hasMounted = true
  },

  methods: {
    didClickItem() {
      this.search = null
    },

    labelDisplay(homeNumber) {
      return _get(homeNumber, 'label') || _get(homeNumber, 'formattedNumber') || _get(homeNumber, 'number')
    },

    numberDisplay(homeNumber) {
      if (_get(homeNumber, 'label')) {
        return _get(homeNumber, 'formattedNumber') || _get(homeNumber, 'number')
      } else {
        return ''
      }
    },

    studentDisplay(homeNumber) {
      var students = _get(homeNumber, 'students')

      if (students.length == 0) {
        return ''
      } else if (students.length == 1) {
        return _get(students[0], 'first') + ' ' + _get(students[0], 'last')
      } else {
        return _get(students[0], 'first') + ' ' + _get(students[0], 'last') + ' and ' + (students.length - 1) + ' more'
      }
    },

    didCreateProposedNewHomeNumber(homeNumber) {
      this.$apollo.mutate({
        mutation: gql`
          mutation homeNumberCreate($teamId:ID!, $number:String!) {
            homeNumberCreate(teamId:$teamId, number:$number) {
              id
            }
          }
        `,
        variables: {
          teamId: this.teamId,
          number: homeNumber.number
        }
      }).then(({data}) => {
        console.log('Cardstock: MessageRecipientForm - successful HomeNumberCreate')
        this.$emit('click')
        this.$router.push({name: 'homeNumber', params: { homeNumberId: data.homeNumberCreate.id}})
      })
    }
  },

  apollo: {
    messageRecipients: {
      query: gql`
      query messageRecipients($teamId:ID!, $search:String) {
        messageRecipients(teamId:$teamId, search:$search) {
          ...on ProvisionalNewHomeNumber {
            __typename
            number
            formattedNumber
          }
          ...on HomeNumber {
            __typename
            id
            number
            formattedNumber
            label
            students {
              id
              first
              last
              gradeLevel {
                id
                name
              }
            }
          }
        }
      }`,
      variables() {
        return {
          teamId: this.teamId,
          search: this.search
        }
      },
      fetchPolicy: 'no-cache',
      debounce: 100
    }
  }
}
</script>
